module.exports = __webpack_public_path__ + "static/media/first.14cb3085.jpg";